/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
	'gameui',[
		'lodash',
		'absolute',
		'MenuUI/LoadingScreen',
		'MenuUI/LoadingSingleScreen',
		'mainmenu',
		'gamescreen',
		'MenuUI/DailyChallengeMenu',
		'MenuUI/StarClubMenu',
		'MenuUI/StarClubCollectionMenu',
		'MenuUI/StarClubChallengeMenu',
		'MenuUI/AwardsMenu',
		'MenuUI/AwardsAchievementsMenu',
		'MenuUI/StatsDetailMenu',
		'MenuUI/ThemesScreen',
		'text!ui/assetmap.json',
		'text!ui/layout.json',
		'text!scaleparams.json',
		'absolute/particlesystem',
		'MenuUI/htp/HtpScreen',
		'MenuUI/WarningModal',
		'MenuUI/CreditsDialog',
		'pixi',
		'Managers/ScaleManager',
		'Managers/ScrollManager'
	],
	function (
		_,
		Absolute,
		LoadingScreen,
		LoadingSingleScreen,
		MainMenu,
		GameScreen,
		DailyChallengeMenu,
		StarClubMenu,
		StarClubCollectionMenu,
		StarClubChallengeMenu,
		AwardsMenu,
		AwardsAchievementsMenu,
		StatsDetailMenu,
		ThemesScreen,
		assetMapJSON,
		layoutJSON,
		scaleParamsJSON,
		ParticleSystem,
		HtpScreen,
		WarningModal,
		CreditsDialog,
		PIXI,
		ScaleManager,
		ScrollManager
	) {
		var GenericGameUI = function (game, config) {
			this._initGenericGameUI(game, config);
			document.getElementById('preLoader').classList.add('loaded');

		};

		GenericGameUI.constuctor = GenericGameUI;
		GenericGameUI.prototype = Object.create(Absolute.GameUI.prototype);

		GenericGameUI.prototype._initGenericGameUI = function (game, config) {

			//                 function(container, width, height, backgroundColor, supportsOrientationChange, supportsLiquidLayout, supportsWebGL, lockAspectRatio) {


			Absolute.GameUI.call(this, config.container, config.width, config.height, config.backgroundColor, Absolute.Platform.supportsDeviceOrientation(), false, true, true);

			Absolute.AssetMap.load(assetMapJSON);
			Absolute.UIBuilder.load(layoutJSON);
			ScaleManager.load(scaleParamsJSON);

			this.game = game;
			this.layout = config.layout;
			Absolute.LayoutHelper.setLayoutMap(this.layout);

			ParticleSystem.init();
			this.particleSystem = ParticleSystem;

		};

		GenericGameUI.prototype.load = function (assets, onLoadProgress, onLoadComplete) {
			if (this.game.config.singleGame.enabled) this.filterOutNonSingleGameAssets(assets);
			var preloader = new Absolute.Loader(),
				loadStartTime = Date.now(),
				minSplashTime = 3000;
			this.loadLanguagePack(Absolute.StringManager.getUserLanguage(), function () {
				var loadingArt = (this.game.config.singleGame.enabled ? 'singlegame' : 'loading');
				preloader.loadArt([loadingArt], function () {
				}, function () {
                        this.blockClicks();
					    this.buildLoadingScreen();
					    this.showScreen(this.loadingScreen);
					    this.loadingScreen.show(true);
                        this.animate();
                        this.unBlockClicks();

					setTimeout(function () {
						var loader = new Absolute.Loader();
						loader.loadAssets(
							assets,
							function (percent) {

								this.loadingScreen.updateLoadingProgress(percent);
								//this.render();
								onLoadProgress(percent);
							}.bind(this),
							function () {


								var loadTime = Date.now() - loadStartTime,
									startDelay = minSplashTime - loadTime;

								if (startDelay < 0) {
									startDelay = 0;
								}
								this.buildGameScreens();
								Absolute.MusicManager.setMuted(Absolute.MusicManager.isMuted());

								// show the splash screen at least 3 seconds
								window.setTimeout(function () {
									if (this.game.config.singleGame.enabled) this.loadingScreen.finishLoadingProgress();
									onLoadComplete();
								}.bind(this), startDelay);


								//this.animate();
							}.bind(this)
						);
					}.bind(this), 0);

				}.bind(this));
			}.bind(this));
		};

		GenericGameUI.prototype.loadLanguagePack = function (lang, callback) {
			jQuery.get('static/localization/strings-' + lang + '.json', function (data) {
				Absolute.StringManager.load(data);
				callback();
			});
		};

		// override
		GenericGameUI.prototype.buildLoadingScreen = function () {
			if (this.game.config.singleGame.enabled) {
				this.loadingScreen = new LoadingSingleScreen(this, this.game);
			} else {
				this.loadingScreen = new LoadingScreen(this, this.game);
			}
		};

		// override
		GenericGameUI.prototype.buildGameScreens = function () {
			ScrollManager.initialize();
			this.gameScreen = new GameScreen(this, this.game);
			this.mainMenu = new MainMenu(this, this.game, getParameterByName('mode'));
		};

		GenericGameUI.prototype.showScreen = function (screen, showAd) {
			Absolute.GameUI.prototype.showScreen.call(this, screen, showAd);
		};

		GenericGameUI.prototype.showMainMenu = function () {
			this.showScreen(this.mainMenu);
		};

		GenericGameUI.prototype.showDailyChallengeMenu = function () {
			if (!this.dailyChallengeMenu) {
				this.dailyChallengeMenu = new DailyChallengeMenu(this, this.game);
			}

			this.showScreen(this.dailyChallengeMenu);
		};

		GenericGameUI.prototype.showAwardsMenu = function (year) {
			if (!this.awardsMenu) {
				this.awardsMenu = new AwardsMenu(this, this.game, year);
			}
			this.awardsMenu.initialize(this, year, this.game);
			this.showScreen(this.awardsMenu);
		};

		GenericGameUI.prototype.showAwardsAchievementsMenu = function () {

			if (!this.awardsAchievementsMenu) {
				this.awardsAchievementsMenu = new AwardsAchievementsMenu(this, this.game);
			}

			this.showScreen(this.awardsAchievementsMenu);
		};

		GenericGameUI.prototype.showStarClubMenu = function () {

			if (!this.starClubMenu) {
				this.starClubMenu = new StarClubMenu(this, this.game);
			}

			this.showScreen(this.starClubMenu);
		};

		GenericGameUI.prototype.showStarClubCollectionMenu = function () {

			if (!this.starClubCollectionMenu) {
				this.starClubCollectionMenu = new StarClubCollectionMenu(this, this.game);
			}

			this.showScreen(this.starClubCollectionMenu);
		};

		GenericGameUI.prototype.showStarClubChallengeMenu = function () {

			if (!this.starClubChallengeMenu) {
				this.starClubChallengeMenu = new StarClubChallengeMenu(this, this.game);
			}

			this.showScreen(this.starClubChallengeMenu);
		};

		GenericGameUI.prototype.setStarClubCollection = function (collection) {

			if (!this.starClubCollectionMenu) {
				this.starClubCollectionMenu = new StarClubCollectionMenu(this, this.game);
			}

			this.starClubCollectionMenu.loadCollection(collection);
		};

		GenericGameUI.prototype.setStarClubChallengePack = function (challengePack) {

			if (!this.starClubChallengeMenu) {
				this.starClubChallengeMenu = new StarClubChallengeMenu(this, this.game);
			}

			this.starClubChallengeMenu.loadChallenges(challengePack);
		};


		GenericGameUI.prototype.setStatsDetailModel = function (statsDetailModel) {

			if (!this.statsDetailMenu) {
				this.statsDetailMenu = new StatsDetailMenu(this, this.game);
			}

			this.statsDetailMenu.loadStats(statsDetailModel);
		};

		GenericGameUI.prototype.showStatsDetailMenu = function () {

			if (!this.statsDetailMenu) {
				this.statsDetailMenu = new StatsDetailMenu(this, this.game);
			}

			this.showScreen(this.statsDetailMenu);
		};

		GenericGameUI.prototype.showThemesScreen = function () {
			if (!this.themesScreen) {
				this.themesScreen = new ThemesScreen(this, this.game);
			}

			this.showScreen(this.themesScreen);
		};

		GenericGameUI.prototype.showGameScreen = function (showAd) {
			this.showScreen(this.gameScreen, showAd);
		};

		GenericGameUI.prototype.beforeRender = function () {
			ParticleSystem.update();
			this.currentScreen.beforeRender();
		};

		GenericGameUI.prototype.afterRender = function () {
			this.currentScreen.afterRender();
		};

		GenericGameUI.prototype.addEmitter = function (emitter) {
			ParticleSystem.addEmitter(emitter);
		};

		GenericGameUI.prototype.removeEmitter = function (emitter) {
			ParticleSystem.removeEmitter(emitter);
		};

		GenericGameUI.prototype.setLevel = function (level) {
			this.gameScreen.setLevel(level);
		};

		GenericGameUI.prototype.showHtpScreen = function (mode) {
			if (!this.htpScreen) {
				this.htpScreen = new HtpScreen(this, this.game);
			}
			this.htpScreen.mode = mode;
			this.showScreen(this.htpScreen);
		};

		GenericGameUI.prototype.showLoadingScreen = function () {
			//this.currentScreen.addChild(this.loadingScreen);
			this.stage[0].addChild(this.loadingScreen);
			this.loadingScreen.show(false);
		};

		GenericGameUI.prototype.hideLoadingScreen = function () {
			this.stage[0].removeChild(this.loadingScreen)
			this.loadingScreen.hide();
		};		

		GenericGameUI.prototype.showWarning = function (title, body, callback) {
			var warningModal = new WarningModal(this.game.ui.currentScreen, title, body,
				function () {
					if (typeof callback == 'function') {
						callback();
					}
					warningModal.close()
				});
		};

		GenericGameUI.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			if (this.game && this.game.menuBar && command === 'FullScreen') {
				this.game.menuBar.handleCommand('FullScreen')
			}
			isMouseWheel = !!isMouseWheel;
			if (window.AH_isAdShowing && window.AH_isAdShowing()) {
				return false;
			} else if (this.hasModal()) {
				this.modalStack[this.modalStack.length - 1].handleCommand(command);
			} else if (this.creditsDialog && this.creditsDialog.showing) {
				if (command == 'Activate') {
					this.creditsDialog.hide();
				}
			} else if (this.game.menuBar.gameOptionsPopup) {
				this.game.menuBar.gameOptionsPopup.handleCommand(command);
				return;
			} else if (command == 'Menu' || (this.game.menuBar && this.game.menuBar.menuOpen)) {
				if (command == 'Menu') {
					this.currentScreen.handleCommand('Unfocus', isMouseWheel);
				}
				this.game.gameScreenUI.handleCommand(command, isMouseWheel);
			} else if (this.currentScreen) {
				this.currentScreen.handleCommand(command, isMouseWheel);
			}
		};

		GenericGameUI.prototype.showCreditsDialog = function () {
			if (!this.creditsDialog) {
				this.creditsDialog = new CreditsDialog();
			}
			this.creditsDialog.show();
		};


		GenericGameUI.prototype.blockClicks = function () {
			if (typeof this.inputInterceptOverlay === 'undefined' || this.inputInterceptOverlay == null) {
				this.inputInterceptOverlay = new PIXI.Graphics();
				this.inputInterceptOverlay.beginFill(0x000001, 0);
				this.inputInterceptOverlay.drawRect(0, 0, this.width, this.height);
				this.inputInterceptOverlay.endFill();
				this.inputInterceptOverlay.hitArea = new PIXI.Rectangle(0, 0, this.width, this.height);
				Absolute.SpriteUtils.bindInteraction(this.inputInterceptOverlay, function () {
				}.bind(this), true);
				this.inputInterceptOverlay.buttonMode = false;
				this.stage[0].addChild(this.inputInterceptOverlay);
			}
		};

		GenericGameUI.prototype.unBlockClicks = function () {
			if (typeof this.inputInterceptOverlay !== 'undefined' || this.inputInterceptOverlay != null) {
				this.stage[0].removeChild(this.inputInterceptOverlay);
				this.inputInterceptOverlay = null;
			}
		};

		GenericGameUI.prototype.filterOutNonSingleGameAssets = function (assets) {
			var redundantArt = [
				'menu', 'htp_starclub', 'htp_dailychallenge', 'fue', 'dc_menu',
				'dailychallenge', 'dailychallenge_bg', 'aw_menu'
			];
			assets.artAssets = _.filter(assets.artAssets, function (asset) {
				return !_.some(redundantArt, function (ra) {
					return ra === asset.name;
				});
			});
		};

		function getParameterByName(name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		}

		return GenericGameUI;
	});

